import React from "react"
import { API, graphqlOperation } from "aws-amplify"
import clsx from "clsx"
import { Formik, Form } from "formik"
import { useSnackbar } from "notistack"
import { useHistory } from "react-router-dom"
import { useRecoilState } from "recoil"
import { v4 as uuid } from "uuid"
import * as Yup from "yup"
import { makeStyles } from "@material-ui/styles"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import InputAdornment from "@material-ui/core/InputAdornment"
import InputLabel from "@material-ui/core/InputLabel"
import Typography from "@material-ui/core/Typography"
import CircularProgress from "@material-ui/core/CircularProgress"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
// import UploadIcon from "@material-ui/icons/CloudUpload"

import Button from "../components/Button"
import Checkbox from "../components/Checkbox"
import DocumentsDialog from "../components/DocumentsDialog"
import RadioButtonsGroup from "../components/RadioButtonsGroup"
import SelectField from "../components/SelectField"
import TextAreaField from "../components/TextAreaField"
import TextField from "../components/TextField"
import { createDisclosure as CreateDisclosure } from "../graphqlCustom/mutations"
import { listDocuments } from "../graphqlCustom/queries"
import currentAssociation from "../store/currentAssociation"
import currentUser from "../store/currentUser"

const useStyles = makeStyles((theme) => ({
  column: {
    margin: 0,
    // padding: 0,
    // "& .MuiGrid-item": {
    //   paddingLeft: 0,
    //   paddingRight: 0,
    // },
  },
  row: {
    padding: `${theme.spacing(4)}px ${theme.spacing(8)}px`,
    // "& > .MuiGrid-container": {
    //   margin: 0,
    // },
  },
  rowOdd: {
    background: theme.palette.grey[200],
  },
}))

const Column = ({ children, ...props }) => {
  const classes = useStyles()

  return (
    <Grid className={classes.column} container spacing={3} item {...props}>
      {children}
    </Grid>
  )
}

const Row = ({ children, odd, ...props }) => {
  const classes = useStyles()

  return (
    <Container
      className={clsx(classes.row, {
        [classes.rowOdd]: odd,
      })}
      {...props}
    >
      <Grid container spacing={0}>
        {children}
      </Grid>
    </Container>
  )
}

export default function Disclosure() {
  const { enqueueSnackbar } = useSnackbar()
  const history = useHistory()
  const [documents, setDocuments] = React.useState({
    BUDGET: [],
    FINANCIAL: [],
    MEETING: [],
  })
  const [loadingComplete, setLoadingComplete] = React.useState(false)
  const newDate = new Date()
  const day = newDate.getDate()
  const month = newDate.getMonth() + 1
  const year = newDate.getFullYear()
  const [association] = useRecoilState(currentAssociation)
  const [user] = useRecoilState(currentUser)
  let documentsProcessed = 0
  // const formSpacing = 5

  React.useEffect(() => {
    async function fetchDocuments(type) {
      try {
        const dbDocuments = await API.graphql(
          graphqlOperation(listDocuments, {
            limit: 200,
            sortDirection: "DESC",
            associationId: association.id,
            typeCreatedAt: {
              beginsWith: {
                type: type,
              },
            },
          })
        )
        console.log(`documents - ${type}`, dbDocuments.data.listDocuments)
        documentsProcessed++
        if (documentsProcessed === Object.keys(documents).length) {
          setLoadingComplete(true)
          console.log("loaded")
        }
        setDocuments({
          ...documents,
          [type]: dbDocuments.data.listDocuments.items,
        })
      } catch (error) {
        console.log("error", error)
        enqueueSnackbar(`Error fetching documents`, {
          variant: "error",
        })
      }
    }

    Object.keys(documents).forEach((type) => fetchDocuments(type))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [association])

  return loadingComplete ? (
    <Formik
      initialValues={{
        unit: "",
        haveLiens: "",
        liensDescription: "",
        reservesAmount: "",
        haveCapitalExpenditures: "",
        capitalExpendituresType: "",
        capitalExpendituresOther: "",
        haveSpecialAssessment: "",
        specialAssessmentAmount: "",
        haveIncreaseMonthly: "",
        increaseMonthlyAmount: "",
        increaseMonthlyEndDate: "",
        haveCompliantAlterations: "",
        compliantAlterationsDescription: "",
        haveLawsuits: "",
        lawsuitsDescription: "",
        disclosureLatestFinancialsId: "",
        disclosureLatestBudgetId: "",
        disclosureLatestMinutesId: "",
        insuranceName: "",
        insuranceAddress: "",
        insuranceContactName: "",
        insurancePhone: "",
        insuranceEmail: "",
        asssessmentAmount: "",
        unpaidAssessmentAmount: "",
        contactEmail: "",
        preparedByName: `${user.firstName} ${user.lastName}`,
        preparedDate: `${year}-${month < 10 ? `0${month}` : month}-${day}`,
      }}
      validationSchema={Yup.object().shape({
        unit: Yup.string().required("Unit required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
        console.log("values", values)

        const submitData = {
          id: uuid(),
          associationId: association.id,
          // owner: user.id,
          // ...values,
        }
        for (const [key, value] of Object.entries(values)) {
          if (value) {
            console.log(`${key}: ${value}`)
            if (value === "yes") {
              submitData[key] = true
            } else if (value === "no") {
              submitData[key] = false
            } else {
              submitData[key] = value
            }
          }
        }
        if (submitData.increaseMonthlyEndDate) {
          const increaseMonthlyEndDate = new Date(submitData.increaseMonthlyEndDate)
          submitData.increaseMonthlyEndDate = increaseMonthlyEndDate.toISOString()
        }
        if (submitData.preparedDate) {
          const preparedDate = new Date(submitData.preparedDate)
          submitData.preparedDate = preparedDate.toISOString()
        }
        console.log("submitData", submitData)

        try {
          // const data =
          const { data } = await API.graphql(
            graphqlOperation(CreateDisclosure, { input: submitData })
          )
          console.log("data", data)

          resetForm()
          setStatus({ success: true })
          enqueueSnackbar("Disclosure created", {
            variant: "success",
          })
          history.push(`/0/sale/${data.createDisclosure.id}`)
        } catch (error) {
          console.log("error", error)
          setStatus({ success: false })
          setErrors({ submit: error.message })
          enqueueSnackbar("There was a problem creating the disclosure", {
            variant: "error",
          })
        } finally {
          setSubmitting(false)
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        isValid,
        touched,
        values,
        setFieldValue,
      }) => {
        return (
          <Form>
            <Row>
              <Column>
                <Grid item xs={12}>
                  <Typography paragraph variant="h1">
                    Start Disclosure
                  </Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                  <TextField
                    autoFocus
                    error={Boolean(touched.unit && errors.unit)}
                    helperText={touched.unit && errors.unit}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">#</InputAdornment>,
                    }}
                    label="Unit Number"
                    name="unit"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.unit}
                  />
                </Grid>
              </Column>
            </Row>
            <Row odd>
              <Column xs={12} md={values.haveLiens === "yes" ? 5 : 12}>
                <Grid item xs={12}>
                  <RadioButtonsGroup
                    error={Boolean(touched.haveLiens && errors.haveLiens)}
                    helperText={touched.haveLiens && errors.haveLiens}
                    label="Are there any liens against the Association?"
                    name="haveLiens"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    options={[
                      {
                        label: "Yes",
                        value: "yes",
                      },
                      {
                        label: "No",
                        value: "no",
                      },
                    ]}
                    type="horizontal"
                    value={values.haveLiens}
                  />
                </Grid>
              </Column>
              {values.haveLiens === "yes" ? (
                <Column xs={12} md={7}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="liensDescription">
                      Please give details concerning all such liens
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12}>
                    <TextAreaField
                      id="liensDescription"
                      label="Add details"
                      value={values.liensDescription}
                      onChange={handleChange}
                    />
                  </Grid>
                </Column>
              ) : (
                ""
              )}
            </Row>
            <Row>
              <Column>
                <Grid item xs={12}>
                  <InputLabel htmlFor="liensDescription">
                    Amount of reserves for capital expenditures
                  </InputLabel>
                </Grid>
                <Grid item xs={12} md={5}>
                  <TextField
                    error={Boolean(touched.reservesAmount && errors.reservesAmount)}
                    helperText={touched.reservesAmount && errors.reservesAmount}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    label="Amount"
                    name="reservesAmount"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.reservesAmount}
                  />
                </Grid>
              </Column>
            </Row>
            <Row odd>
              <Column xs={12} md={values.haveCapitalExpenditures === "yes" ? 5 : 12}>
                <Grid item xs={12}>
                  <RadioButtonsGroup
                    defaultValue={values.haveCapitalExpenditures}
                    label="Are there any capital expenditures anticipated by the Association for the current or next two (2) fiscal years which would require a special assessment or increase in the monthly assessment to the unit owners?"
                    name="haveCapitalExpenditures"
                    onChange={handleChange}
                    options={[
                      {
                        label: "Yes",
                        value: "yes",
                      },
                      {
                        label: "No",
                        value: "no",
                      },
                    ]}
                    type="horizontal"
                  />
                </Grid>
              </Column>
              {values.haveCapitalExpenditures === "yes" ? (
                <Column xs={12} md={7}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="capitalExpendituresType">
                      Please describe the nature of the expenditure
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12}>
                    <SelectField
                      style={{ backgroundColor: "white" }}
                      defaultValue={values.capitalExpendituresType}
                      label="Reason"
                      name="capitalExpendituresType"
                      onChange={handleChange}
                      options={[
                        {
                          label: "Roofing",
                          value: "Roofing",
                        },
                        {
                          label: "Masonry",
                          value: "Masonry",
                        },
                        {
                          label: "Plumbing",
                          value: "Plumbing",
                        },
                        {
                          label: "Electrical",
                          value: "Electrical",
                        },
                        {
                          label: "Patio/Deck",
                          value: "Patio/Deck",
                        },
                        {
                          label: "Windows",
                          value: "Windows",
                        },
                        {
                          label: "Doors",
                          value: "Doors",
                        },
                        {
                          label: "Flooring",
                          value: "Flooring",
                        },
                        {
                          label: "Sprinklers",
                          value: "Sprinklers",
                        },
                        {
                          label: "Legal Matter/Litigation",
                          value: "Legal Matter/Litigation",
                        },
                        {
                          label: "Other",
                          value: "Other",
                        },
                      ]}
                    />
                  </Grid>
                  {values.capitalExpendituresType === "Other" ? (
                    <Grid item xs={12}>
                      <TextField
                        style={{ background: "white" }}
                        defaultValue={values.capitalExpendituresOther}
                        label="If other, describe"
                        name="capitalExpendituresOther"
                        onChange={handleChange}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  <Grid item xs={12}>
                    <InputLabel htmlFor="liensDescription">
                      Give the amount of the anticipated capital expenditures and the amount of the
                      special assessment to this unit owner or the amount of increase in monthly
                      assessment for this unit owner
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={values.haveSpecialAssessment ? 5 : 12}>
                    <Checkbox
                      defaultValue={values.haveSpecialAssessment}
                      label="Special assessment"
                      name="haveSpecialAssessment"
                      onChange={handleChange}
                    />
                  </Grid>
                  {values.haveSpecialAssessment ? (
                    <Grid item xs={12} md={7}>
                      <TextField
                        style={{ background: "white" }}
                        defaultValue={values.specialAssessmentAmount}
                        label="Total amount"
                        name="specialAssessmentAmount"
                        onChange={handleChange}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}

                  <Grid item xs={12} md={values.haveIncreaseMonthly ? 5 : 12}>
                    <Checkbox
                      defaultValue={values.haveIncreaseMonthly}
                      label="Increased monthly assessment"
                      name="haveIncreaseMonthly"
                      onChange={handleChange}
                    />
                  </Grid>
                  {values.haveIncreaseMonthly ? (
                    <>
                      <Grid item xs={12} md={7}>
                        <TextField
                          style={{ background: "white" }}
                          defaultValue={values.increaseMonthlyAmount}
                          label="Amount of increase"
                          name="increaseMonthlyAmount"
                          onChange={handleChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={7}>
                        <TextField
                          style={{ background: "white" }}
                          defaultValue={values.increaseMonthlyEndDate}
                          label="End Date"
                          id="increaseMonthlyEndDate"
                          onChange={handleChange}
                          type="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}
                </Column>
              ) : (
                ""
              )}
            </Row>
            <Row>
              <Column xs={12} md={values.haveCompliantAlterations === "no" ? 5 : 12}>
                <Grid item xs={12}>
                  <RadioButtonsGroup
                    defaultValue={values.haveCompliantAlterations}
                    label="Any improvements or alterations in the above referenced unit, or in the limited common elements assigned to the unit by the current and any prior owners, are in good faith believed to be in compliance with the Condominium Declaration."
                    name="haveCompliantAlterations"
                    onChange={handleChange}
                    options={[
                      {
                        label: "Yes",
                        value: "yes",
                      },
                      {
                        label: "No",
                        value: "no",
                      },
                    ]}
                    type="horizontal"
                  />
                </Grid>
              </Column>
              {values.haveCompliantAlterations === "no" ? (
                <Column item xs={12} md={7}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="compliantAlterationsDescription">
                      Please specify those items not in compliance with the Condominium Declaration
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12}>
                    <TextAreaField
                      id="compliantAlterationsDescription"
                      label="Add details"
                      value={values.compliantAlterationsDescription}
                      onChange={handleChange}
                    />
                  </Grid>
                </Column>
              ) : (
                ""
              )}
            </Row>
            <Row odd>
              <Column xs={12} md={values.haveLawsuits === "yes" ? 5 : 12}>
                <Grid item xs={12}>
                  <RadioButtonsGroup
                    defaultValue={values.haveLawsuits}
                    label="Are there pending lawsuits or judgments against the Association?"
                    name="haveLawsuits"
                    onChange={handleChange}
                    options={[
                      {
                        label: "Yes",
                        value: "yes",
                      },
                      {
                        label: "No",
                        value: "no",
                      },
                    ]}
                    type="horizontal"
                  />
                </Grid>
              </Column>
              {values.haveLawsuits === "yes" ? (
                <Column xs={12} md={7}>
                  <Grid item xs={12}>
                    <InputLabel htmlFor="lawsuitsDescription">
                      Please give details and status of any such pending lawsuit or judgment
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12}>
                    <TextAreaField
                      id="lawsuitsDescription"
                      label="Add details"
                      value={values.lawsuitsDescription}
                      onChange={handleChange}
                    />
                  </Grid>
                </Column>
              ) : (
                ""
              )}
            </Row>
            <Row>
              <Column xs={12} md={7}>
                <Grid item xs={12}>
                  <InputLabel htmlFor="disclosureLatestFinancialsId">
                    Attach a copy of the Association's latest financial statement
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  {documents.FINANCIAL.length ? (
                    <DocumentsDialog
                      files={documents.FINANCIAL}
                      setter={setFieldValue}
                      type="disclosureLatestFinancialsId"
                      // value={values.disclosureLatestFinancialsId}
                    />
                  ) : (
                    "No financials, upload in Documents"
                    // <Button>Attach Financials</Button>
                    // <TextField
                    //   id="financialUpload"
                    //   label="Upload Financials"
                    //   type="file"
                    //   InputProps={{
                    //     startAdornment: (
                    //       <InputAdornment position="start">
                    //         <UploadIcon />
                    //       </InputAdornment>
                    //     ),
                    //   }}
                    // />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="disclosureLatestBudgetId">
                    Attach a copy of the Association's latest operating budget
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  {documents.BUDGET.length ? (
                    <DocumentsDialog
                      files={documents.BUDGET}
                      setter={setFieldValue}
                      type="disclosureLatestBudgetId"
                      // value={values.disclosureLatestBudgetId}
                    />
                  ) : (
                    "No budgets, upload in Documents"
                    // <Button>Attach Budget</Button>
                    // <TextField
                    //   id="budgetUpload"
                    //   label="Upload Budget"
                    //   type="file"
                    //   InputProps={{
                    //     startAdornment: (
                    //       <InputAdornment position="start">
                    //         <UploadIcon />
                    //       </InputAdornment>
                    //     ),
                    //   }}
                    // />
                  )}
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="disclosureLatestMinutesId">
                    Attach a copy of the board minutes showing capital expenditures and/or approval
                    of special assessments
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  {documents.MEETING.length ? (
                    <DocumentsDialog
                      files={documents.MEETING}
                      setter={setFieldValue}
                      type="disclosureLatestMinutesId"
                      // value={values.disclosureLatestMinutesId}
                    />
                  ) : (
                    "No meeting minutes, upload in Documents"
                    // <TextField
                    //   id="minutesUpload"
                    //   label="Upload Minutes"
                    //   type="file"
                    //   InputProps={{
                    //     startAdornment: (
                    //       <InputAdornment position="start">
                    //         <UploadIcon />
                    //       </InputAdornment>
                    //     ),
                    //   }}
                    // />
                  )}
                </Grid>
              </Column>
            </Row>
            <Row odd>
              <Column>
                <Grid item xs={12}>
                  <InputLabel htmlFor="asssessmentAmount">
                    Current monthly assessment for this unit
                  </InputLabel>
                </Grid>
                <Grid item xs={12} md={5}>
                  <TextField
                    error={Boolean(touched.asssessmentAmount && errors.asssessmentAmount)}
                    helperText={touched.asssessmentAmount && errors.asssessmentAmount}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    label=""
                    name="asssessmentAmount"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.asssessmentAmount}
                  />
                </Grid>
              </Column>
            </Row>
            <Row>
              <Column>
                <Grid item xs={12}>
                  <InputLabel htmlFor="unpaidAssessmentAmount">
                    Amount of unpaid assessments or other charges due and owing
                  </InputLabel>
                </Grid>
                <Grid item xs={12} md={5}>
                  <TextField
                    error={Boolean(touched.unpaidAssessmentAmount && errors.unpaidAssessmentAmount)}
                    helperText={touched.unpaidAssessmentAmount && errors.unpaidAssessmentAmount}
                    InputProps={{
                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                    }}
                    label=""
                    name="unpaidAssessmentAmount"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.unpaidAssessmentAmount}
                  />
                </Grid>
              </Column>
            </Row>
            <Row odd>
              <Column>
                <Grid item xs={12}>
                  <InputLabel htmlFor="insuranceName">
                    Association insurance carrier information:
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    defaultValue={values.insuranceName}
                    label="Company Name"
                    id="insuranceName"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    defaultValue={values.insuranceAddress}
                    label="Company Address"
                    id="insuranceAddress"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    defaultValue={values.insuranceContactName}
                    label="Contact Name"
                    id="insuranceContactName"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    defaultValue={values.insurancePhone}
                    label="Contact Phone"
                    id="insurancePhone"
                    onChange={handleChange}
                    type="tel"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    defaultValue={values.insuranceEmail}
                    label="Contact Email"
                    id="insuranceEmail"
                    onChange={handleChange}
                    type="email"
                  />
                </Grid>
              </Column>
            </Row>
            <Row>
              <Column>
                <Grid item xs={12}>
                  <InputLabel htmlFor="contactEmail">
                    All Notices regarding the Association shall be directed to:
                  </InputLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    defaultValue={values.contactEmail}
                    label="Email"
                    id="contactEmail"
                    onChange={handleChange}
                    type="email"
                  />
                </Grid>
                <Grid item xs={12}>
                  <InputLabel htmlFor="preparedByName">Prepared by</InputLabel>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    defaultValue={values.preparedByName}
                    label="Full name"
                    id="preparedByName"
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    defaultValue={values.preparedDate}
                    label="Date"
                    id="preparedDate"
                    onChange={handleChange}
                    type="date"
                  />
                </Grid>
              </Column>
            </Row>
            <Row>
              <Column>
                <Grid container justifyContent="flex-end" item xs={12}>
                  <Button
                    disabled={isSubmitting}
                    endIcon={<ChevronRightIcon />}
                    isLoading={isSubmitting}
                    type="submit"
                  >
                    Save Disclosure
                  </Button>
                </Grid>
              </Column>
            </Row>
          </Form>
        )
      }}
    </Formik>
  ) : (
    <Grid container alignContent="center" justifyContent="center">
      <CircularProgress />
    </Grid>
  )
}
